import S_factoryTag from '@/service/api/v1/factory_tag';
import H_relatedModuleDeleteInfo from '@/helpers/relatedModuleDeleteInfo';

const DELETE_IN_USE_TEXT = '下列項目正在使用此標籤，如刪除將會移除標籤';

export default {
  setDropdownCustomItems(rawItems) {
    return [{
      menu: this.setItems(rawItems),
      isCustom: true,
    }];
  },
  setItems(rawItems) {
    return rawItems.map(item => ({
      text: item.name,
      value: item.id,
      sequence: item.sequence
        ? item.sequence
        : null,
    }));
  },
  setDeleteInfo(rawData) {
    return H_relatedModuleDeleteInfo.setDeleteInfo(rawData, DELETE_IN_USE_TEXT);
  },
  async setDeletePopupInfo($event) {
    const {value: tagId} = $event;
    const res = await S_factoryTag.show(tagId);
    return this.setDeleteInfo(res);
  },
  setShowInModule(rawDataList) {
    return rawDataList.map(({
      id,
      name: tagName,
    }) => ({
      id,
      text: `#${tagName}`,
      color: 'gray',
    }));
  },
}
